module.exports = __webpack_public_path__ + "static/media/p208motor1.9cf7d4ec.jpg";